import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PressKit } from '@modules/content-api/adapter/press-kit.adapter';
import { PressKitResolver } from '@modules/content-api/resolver/press-kit.resolver';
import { DataLayerService } from '@modules/shared/services/data-layer.service';
import { ActionIcons, ButtonItem } from '@modules/ui/action-container/action-container.component';
import { TranslateService } from '@ngx-translate/core';
import { Subject, take, takeUntil } from 'rxjs';

@Component({
  selector: 'mb-press-kit-page',
  templateUrl: './press-kit-page.component.html',
  styleUrls: ['./press-kit-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PressKitPageComponent implements OnInit, OnDestroy {
  public pressKit!: PressKit;
  public defaultActions: ButtonItem[] = [
    {
      icon: ActionIcons.SHARE,
      class: 'btn btn-plain d-none d-sm-inline-flex',
    },
    {
      icon: ActionIcons.DOWNLOAD,
      class: 'btn btn-plain d-none d-sm-inline-flex',
    },
    {
      icon: ActionIcons.BOOKMARK,
      class: 'btn btn-plain',
    },
  ];
  public sectionActions: ButtonItem[] = [
    {
      icon: ActionIcons.DOWNLOAD,
      label: 'DOWNLOAD',
      class: 'btn btn-plain',
    },
  ];
  public pressKitActions: ButtonItem[] = [
    {
      icon: ActionIcons.SHARE,
      label: 'SHARE',
      class: 'btn btn-plain',
    },
    {
      icon: ActionIcons.DOWNLOAD,
      label: 'DOWNLOAD',
      class: 'btn btn-plain',
    },
    {
      icon: ActionIcons.BOOKMARK,
      label: 'SAVE',
      class: 'btn btn-plain',
    },
  ];

  private destroy$ = new Subject<boolean>();

  constructor(
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef,
    private resolver: PressKitResolver,
    private dataLayerService: DataLayerService
  ) {}

  ngOnInit(): void {
    this.route.data.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data.pressKit) {
        this.pressKit = data.pressKit;
        this.cdr.detectChanges();
        this.pushPageViewDataLayer();
      }
    });

    this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.resolver
        .resolve(this.route.snapshot)
        .pipe(take(1))
        .subscribe((pressKit) => {
          if (pressKit) {
            this.pressKit = pressKit;
            this.cdr.detectChanges();
            this.pushPageViewDataLayer();
          }
        });
    });
  }

  private pushPageViewDataLayer() {
    this.dataLayerService.pushPageView({
      id: this.pressKit.id,
      type: 'press_kit',
      name: this.pressKit.title,
      publishDate: this.pressKit.displayDate,
      marsOriginId: this.pressKit.marsOriginId,
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
